// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Y5B-","label":"Labeled_label__1knf3","divider":"Labeled_divider__7RjI-"};